<template>
  <m-card207
      :image="product.thumbnail"
      :alt="product.name"
      class="product-card-207 "
  >
    <template #p-1>
      <p class="p-0 m-0">{{ contentSlicer(product.name, 55) }}</p>
    </template>
    <template #p-2>
      <div class=""></div>
    </template>

    <template #p-3>
      <m-product-price200 class="text-center mb-3 product-card-312-price" :product="product"/>

      <button class="btn btn-primary rounded-pill" @click="addProductToUnAuthenticatedShoppingCart()">
        {{ addToCartText(product) }}
      </button>
      <teleport to="body">
        <div class="modal fade show" id="cashOnDelivery" tabindex="-1"
             aria-labelledby="exampleModalLabel"
             aria-hidden="true">
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">

                <m-un-authenticated-shopping-cart2
                    v-if="showUnAuthenticatedComponent"
                    :hide-refresh-shopping-cart-button="false"
                    default-gate="zarinpal"
                    :address-required="false"
                    :setUnauthenticatedShoppingCartFromLoginUser="false"
                    :order_description_prop="true"
                    :postal_code_prop="false"
                    :advanceDescription="false"
                    :activeShoppingCartForm="true"
                    :hide-signup-button="false"
                />

              </div>
            </div>
          </div>
        </div>
      </teleport>


    </template>
  </m-card207>
</template>

<script>
import {shoppingCartFunctions} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";
import mCard207 from "../../Cards/Card207";
import mA from "../../Tags/A";
import mProductCardQuantityManager1 from "../../Product/QuantityManager/Card/ProductCardQuantityManager1";
import mProductPrice200 from "../../Product/ProductPrice200";
import mProductOffer1 from "../../Product/ProductOffer/ProductOffer1";
import {OfferProps} from "../ProductOffer/ProductOfferProps";
import {
  addFeatureToProduct,
  featureCategories,
  findFeatureWithSelectedName,
  groupByType,
  productFeatureValue,
  removeChildFeature,
  removeEmptyGroups,
  sortedFeaturesMethod,
} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import {contentSlicer} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ContentFunctions";
import mUnAuthenticatedShoppingCart2 from "../../UnAuthenticatedShoppingCart/UnAuthenticatedShoppingCart2.vue";
import $ from 'jquery'

export default {
  name: "ProductCard207",
  components: {
    mUnAuthenticatedShoppingCart2,
    mCard207,
    mA,
    mProductCardQuantityManager1,
    mProductPrice200,
    mProductOffer1,
  },
  props: {
    product: {},
    ...OfferProps,
  },
  data() {
    return {
      $,
      showUnAuthenticatedComponent: false
    }
  },
  methods: {
    contentSlicer,
    ...shoppingCartFunctions,
    findFeatureWithSelectedName,
    addToCartText(product) {
      if (product.is_digital) {
        return this.$t('product.add_to_cart_physical')
      }
      return this.$t('product.add_to_cart_digital')
    },
    async addProductToUnAuthenticatedShoppingCart() {


      this.showUnAuthenticatedComponent = false
      localStorage.removeItem('products')

      await this.addUnAuthItem(this.product, null, null, this.redirectAfterAddDigitalProduct)


      await $('#cashOnDelivery').modal('show')
      this.showUnAuthenticatedComponent = true

      let storageEvent = new Event(`unauthenticatedShoppingCardDescriptionEmpty`);
      window.dispatchEvent(storageEvent);

    },
  },
};
</script>

<style scoped>
.card207-icon {
  width: 36px;
  height: 32px;
  object-fit: cover;
  border-radius: 7px;
}
</style>
